import { Types } from "../actions/fssReportActions";
import _, { groupBy } from "lodash";
import { NotificationManager } from "react-notifications";

import cleanDeep from "clean-deep";

const defaultState = {
	my: {},
};

const fssReportReducers = (state = defaultState, action) => {
	console.log("infssReportReducers", action.type);
	switch (action.type) {
		case Types.FSSREPORT_V2_REPORTS: {
			let newState = _.cloneDeep(state);

			newState.showV2Reports = !newState.showV2Reports;
			newState.fssReports = [];

			return newState;
		}
		case Types.FSSREPORT_UPDATING: {
			let newState = _.cloneDeep(state);

			newState.fssReportUpdating = action.status ? action.status : undefined;
			if (action.status) newState.fssReports = [];

			return newState;
		}

		case Types.FSSREPORT_ORGANISATIONS: {
			let newState = _.cloneDeep(state);
			newState.fssExpress = {
				...newState.fssExpress,
				organisations: action.payload,
			};

			return newState;
		}
		case Types.FSSREPORT_EXPRESS_COMPANY: {
			let newState = _.cloneDeep(state);

			const peNumberToUpdate = action.peNumber;

			const selectedOrganisations = newState.fssExpress?.selectedOrganisations || [];
			const selectedOrg = selectedOrganisations.findIndex((pe) => pe.peNumber == peNumberToUpdate);

			const existingSelected = selectedOrganisations[selectedOrg];

			selectedOrganisations[selectedOrg] = {
				...existingSelected,
				...action.payload,
			};

			newState.fssExpress = {
				...newState.fssExpress,
				selectedOrganisations,
			};

			return newState;
		}
		case Types.FSSREPORT_SELECTED_COMPANIES: {
			let newState = _.cloneDeep(state);
			if (action.clear) {
				newState.fssExpress = {
					...newState.fssExpress,
					selectedOrganisations: undefined,
				};
				return newState;
			}
			const selectedOrganisations = newState.fssExpress.selectedOrganisations || [];

			const existingOrganisations = newState.fssExpress?.organisations?.find(
				(pe) => pe.peNumber == action.peNumber,
			);
			const existingOrgIds = existingOrganisations?.org
				? [existingOrganisations?.org]
				: existingOrganisations?.options?.map((org) => org.org) || [];

			if (action.checked) {
				newState.fssExpress.selectedOrganisations = [
					...selectedOrganisations,
					{ peNumber: action.peNumber, organisations: existingOrgIds },
				];
			} else {
				newState.fssExpress.selectedOrganisations = selectedOrganisations.filter(
					(pe) => pe.peNumber != action.peNumber,
				);
			}
			return newState;
		}
		case Types.FSSREPORT_OPEN_EID_MODAL: {
			let newState = _.cloneDeep(state);

			newState.submissionForm = {
				...newState.submissionForm,
				eidLoginModal: action.status ? action.status : undefined,
				error: action.status ? newState.submissionForm?.error : undefined,
			};

			return newState;
		}
		case Types.FSSREPORT_VALIDATION_RESULT: {
			let newState = _.cloneDeep(state);

			newState.submissionForm = {
				...newState.submissionForm,
				validationResult: action.response ? action.response : undefined,
			};

			return newState;
		}
		case Types.FSSREPORT_OPEN_VALIDATION_MODAL: {
			let newState = _.cloneDeep(state);

			newState.submissionForm = {
				...newState.submissionForm,
				validationModal: action.status ? action.status : undefined,
				validationResult: { errors: action.errors },
			};

			return newState;
		}
		case Types.FSSREPORT_LOADING_FS7_VALIDATION: {
			let newState = _.cloneDeep(state);

			newState.submissionForm.loadingValidation = action.status ? action.status : undefined;
			newState.submissionForm.submittingFS7 = action.submit ? action.submit : undefined;

			return newState;
		}
		case Types.FSSREPORT_LOADING_EID_CREDENTIALS: {
			let newState = _.cloneDeep(state);

			newState.submissionForm.loadingEID = action.status ? action.status : undefined;

			return newState;
		}
		case Types.FSSREPORT_LOGIN_ERROR: {
			let newState = _.cloneDeep(state);

			newState.submissionForm.error = action.error ? action.error : undefined;

			return newState;
		}
		case Types.FSSREPORT_SAVED_EID_CREDENTIALS: {
			let newState = _.cloneDeep(state);

			newState.submissionForm = _.merge(newState.submissionForm, {
				credentials: action.status ? action.status : undefined,
				...action.response,
			});

			return newState;
		}
		case Types.FSSREPORT_SELECT_FORM: {
			let newState = _.cloneDeep(state);

			const form = newState.fssReports?.find((item) => item["type-period"] == `${action.form}-${action.year}`);

			newState.submissionForm = form ? { ...form, form: action.form } : undefined;

			return newState;
		}
		case Types.FSSREPORT_UPDATE: {
			let newState = _.cloneDeep(state);

			newState.fssReports = action.payload;

			if (action.payload[0] && action.payload[0].name) {
				newState.fssReports = _.orderBy(action.payload, [(item) => item.name?.toLowerCase()], ["asc"]);
			}

			return newState;
		}
		case Types.FSSREPORT_UPDATE_SINGLE: {
			let newState = _.cloneDeep(state);

			const index = newState.fssReports.findIndex((item) => item.id == action.payload.id);

			newState.fssReports[index] = action.payload;

			return newState;
		}
		case Types.FSSREPORT_DOWNLOADING: {
			let newState = _.cloneDeep(state);

			if (!newState.fssDownloading) {
				newState.fssDownloading = {};
			}

			newState.fssDownloading[action.index] = action.processing;

			return newState;
		}
		case Types.FSSREPORT_REGENERATE_MODAL: {
			let newState = _.cloneDeep(state);

			newState.fssRegenerateModal = { status: action.status, year: action.year, reportType: action.reportType };

			return newState;
		}

		case Types.FSSREPORT_REGENERATING: {
			let newState = _.cloneDeep(state);

			newState.fssRegenerateModal.regenerating = action.status;

			return newState;
		}
		case Types.FSSREPORT_FORM_DOWNLOAD_STATUS: {
			let newState = _.cloneDeep(state);
			newState.fssDownloading = { ...newState.fssDownloading, [action.form]: action.status };
			return newState;
		}
		case Types.FSSREPORT_SAVING_CIS_DEDUCTIONS: {
			let newState = _.cloneDeep(state);
			if (!newState.taxForms.cisDeductionsSaving) newState.taxForms.cisDeductionsSaving = [];

			if (action.status) {
				newState.taxForms.cisDeductionsSaving.push(action.id);
			} else {
				newState.taxForms.cisDeductionsSaving = newState.taxForms.cisDeductionsSaving.filter(
					(id) => id != action.id,
				);
			}

			return newState;
		}
		case Types.FSSREPORT_CIS_MODAL: {
			let newState = _.cloneDeep(state);

			if (!newState.taxForms) newState.taxForms = {};

			if (!action.report) {
				delete newState.taxForms.cisModal;
			} else {
				newState.taxForms.cisModal = action.report;
			}

			return newState;
		}
		case Types.FSSREPORT_OPEN_TAX_FORM_IMPORT_MODAL: {
			let newState = _.cloneDeep(state);

			newState.taxForms = {
				...newState.taxForms,
				importModal: action.status ? action.status : undefined,
			};

			return newState;
		}
		case Types.FSSREPORT_PROCESSING_IMPORT: {
			let newState = _.cloneDeep(state);

			newState.taxForms = {
				...newState.taxForms,
				uploading: action.status ? action.status : undefined,
			};

			return newState;
		}
		case Types.FSSREPORT_IMPORT_RESULT: {
			let newState = _.cloneDeep(state);

			newState.taxForms = {
				...newState.taxForms,
				uploadResults: action.response,
			};

			return newState;
		}
		default:
			return state;
	}
};

export default fssReportReducers;
